<template>
	<transition
		name="sliding-sheet-overlay"
		appear
	>
		<div
			v-if="isOpen"
			class="sliding-sheet-overlay"
			@click="handleOverlayClick"
		>
			<transition
				name="sliding-sheet"
				appear
			>
				<div
					v-if="isOpen"
					class="sliding-sheet"
					:class="sheetClasses"
					:style="sheetStyle"
					@click.stop
				>
					<div class="sliding-sheet-header">
						<div class="sliding-sheet-title">
							<slot name="header">
								<h3>
									{{ title }}
								</h3>
							</slot>
						</div>
						<button
							class="sliding-sheet-close"
							:aria-label="closeButtonAriaLabel"
							@click="$emit('close')"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
							>
								<line
									x1="18"
									y1="6"
									x2="6"
									y2="18"
								/>
								<line
									x1="6"
									y1="6"
									x2="18"
									y2="18"
								/>
							</svg>
						</button>
					</div>

					<div class="sliding-sheet-content overflow-y-auto">
						<slot name="content">
							<slot />
						</slot>
					</div>

					<div
						v-if="$slots.footer"
						class="sliding-sheet-footer text-right"
					>
						<slot name="footer" />
					</div>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'sliding-sheet',
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: '400px'
		},
		closeOnOverlayClick: {
			type: Boolean,
			default: true
		},
		closeButtonAriaLabel: {
			type: String,
			default: 'Close sheet'
		}
	},
	computed: {
		sheetClasses () {
			return {
				'sliding-sheet--custom-width': this.width !== '400px'
			}
		},
		sheetStyle () {
			return {
				width: this.width
			}
		}
	},
	watch: {
		isOpen (newVal) {
			if (newVal) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = ''
			}
		}
	},
	beforeDestroy () {
		document.body.style.overflow = ''
	},
	methods: {
		handleOverlayClick () {
			if (this.closeOnOverlayClick) {
				this.$emit('close')
			}
		}
	}
}
</script>

<style scoped>
.sliding-sheet-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}

.sliding-sheet {
  background: var(--global-card-background, white);
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  max-width: 90vw;
}

.sliding-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--global-border-color);
  background: var(--global-main-background-color);
}

.sliding-sheet-title {
  flex: 1;
  margin: 0;
}

.sliding-sheet-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--global-foreground);
}

.sliding-sheet-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius-sm, 4px);
  color: var(--global-foreground);
  transition: background-color 0.2s, color 0.2s;
  margin-left: 16px;
}

.sliding-sheet-close:hover {
  background-color: #e9ecef;
  color: var(--global-foreground);
}

.sliding-sheet-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.sliding-sheet-footer {
  padding: 12px 20px;
  border-top: 1px solid var(--global-border-color);
  background: var(--global-main-background-color);
}

/* Transitions */
.sliding-sheet-overlay-enter-active,
.sliding-sheet-overlay-leave-active {
  transition: opacity 0.3s ease;
}

.sliding-sheet-overlay-enter,
.sliding-sheet-overlay-leave-to {
  opacity: 0;
}

.sliding-sheet-enter-active,
.sliding-sheet-leave-active {
  transition: transform 0.3s ease;
}

.sliding-sheet-enter,
.sliding-sheet-leave-to {
  transform: translateX(100%);
}
</style>
